<template>
    <div class="changewarp">
        <Header title="异动"></Header>
        <div class="changecontent">
            <div class="header">
                <div class="ht">
                    <div class="name">{{ this.xm }}</div>
                    <div class="num">({{ this.xh }})</div>
                </div>
                <div class="hb">
                    <div>年级：{{ this.xsnj }}</div>
                    <div>学院：{{ this.dwmc }}</div>
                    <div>专业：{{ this.zymc }}</div>
                    <div>班级：{{ this.bj }}</div>
                </div>
            </div>
            <div class="list">
                <div class="listBox">
                    <div class="package" v-for="(item, index) in dataList" :key="index">
                        <div class="lbtop">
                            <div class="name">{{ item.ydlb }}</div>
                            <div class="details" @click="showPopup">详情</div>
                        </div>
                        <van-popup v-model="show" closeable round>
                            <div class="springFrame">
                                <div class="title">异动</div>
                                <ul>
                                    <li>异动前年级：{{ item.ydqnj }}</li>
                                    <li>异动后年级：{{ item.ydhnj }}</li>
                                    <li>原学院：{{ item.ydqxy }}</li>
                                    <li>新学院：{{ item.ydhxy }}</li>
                                    <li>原专业：{{ item.ydqzy }}</li>
                                    <li>新专业：{{ item.ydhzy }}</li>
                                    <li>原班级：{{ item.ydqbj }}</li>
                                    <li class="newli">新班级：{{ item.ydhbj }}</li>
                                    <li>原在校状态：{{ item.oldzxzt }}</li>
                                    <li class="newli">新在校状态：{{ item.newzxzt }}</li>
                                    <li>休学开始日期：{{ item.xxksrq }}</li>
                                    <li>休学开始日期：{{ item.xxjsrq }}</li>
                                </ul>
                                <button @click="show = false">知道了</button>
                            </div>
                        </van-popup>
                        <div class="lbbottom">
                            <div>异动日期：{{ item.ydrq }}</div>
                            <div>异动原因：{{ item.ydyy }}</div>
                        </div>
                    </div>
                    <NOdata title="暂无搜索结果~" v-if="this.dataList.length == 0"></NOdata>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Api } from '../../../../utils/axios';

export default {
    data() {
        return {
            show: false,
            xsydList: '',
            xm: '',
            xh: '',
            xsnj: '',
            dwmc: '',
            zymc: '',
            bj: '',
            dataList: []
        };
    },
    created() {
        this.xsydList = this.$route.query.xs0101id;
        (this.xm = this.$route.query.xm), (this.xh = this.$route.query.xh), (this.xsnj = this.$route.query.xsnj), (this.dwmc = this.$route.query.dwmc), (this.zymc = this.$route.query.zymc), (this.bj = this.$route.query.bj), this.getXjydHandleQuery();
    },
    methods: {
        showPopup() {
            this.show = true;
        },
        async getXjydHandleQuery() {
            const params = {
                xs0101id: this.xsydList
            };
            const res = await Api.getXjydHandleQuery(params);
            this.dataList = res.data;
        }
    }
};
</script>

<style scoped lang="less">
.changewarp {
    .changecontent {
        .header {
            .ht {
                display: flex;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                margin-left: 26px;
            }
            .hb {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                margin-top: 5px;
                padding-bottom: 12px;
                margin-left: 24px;

                div {
                    padding: 5px 7px 0 0px;
                }
            }
        }
        .list {
            width: 100%;
            height: 100vh;
            background: #f6f6f6;
            .listBox {
                width: 100%;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .package {
                    width: 85%;
                    background: #ffffff;
                    margin-top: 10px;
                    padding: 12px 15px;
                    border-radius: 6px;
                    .lbtop {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        .name {
                            font-weight: 500;
                            font-size: 16px;
                            color: #333333;
                        }
                        .details {
                            font-weight: 400;
                            font-size: 14px;
                            color: #0189f9;
                        }
                    }
                    .lbbottom {
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        margin-top: 7px;
                    }
                    .springFrame {
                        width: 100%;
                        height: 100%;
                        .title {
                            font-weight: 500;
                            font-size: 18px;
                            color: #333333;
                            line-height: 18px;
                            margin: 20px;
                        }
                        ul {
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            line-height: 21px;
                            margin: 10px 20px;
                            li {
                                margin: 2px 0;
                            }
                            .newli {
                                font-weight: 500;
                                color: #333333;
                            }
                        }
                        button {
                            width: 271px;
                            height: 42px;
                            background: #0189f9;
                            border-radius: 4px;
                            color: #ffffff;
                            margin: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/informationService/change.vue